import { Navigate, useParams } from 'react-router-dom';

import { FlexCol, FlexRow } from '@/components/ui/flex';
import { AskPage } from '@/pages/Ask';
import { paths, regulatoryWatchPaths } from '@/paths';
import { useWorkspaceFeaturesService } from '@/services/workspaceFeatures';
import { Skeleton } from '../ui/skeleton';

export const HomepageRouter = () => {
  const { workspaceUname } = useParams<{ workspaceUname: string }>();
  const {
    isChatEnabled,
    isLiteratureReviewEnabled,
    isRegulatoryWatchEnabled,
    isMcpEnabled,
    isPending,
  } = useWorkspaceFeaturesService();

  if (isPending) {
    return (
      <FlexCol
        h="full"
        w="full"
        gap="14"
        className="bg-background items-center justify-center"
      >
        <FlexCol gap="8" alignItems="center">
          <Skeleton className="w-[374px] h-8" />
          <Skeleton className="w-[956px] h-[145px]" />
        </FlexCol>
        <FlexCol gap="4">
          <Skeleton className="w-[208px] h-6" />
          <FlexRow gap="4">
            <Skeleton className="w-[470px] h-[231px]" />
            <Skeleton className="w-[470px] h-[231px]" />
          </FlexRow>
        </FlexCol>
      </FlexCol>
    );
  }

  if (
    !isChatEnabled &&
    !isLiteratureReviewEnabled &&
    !isRegulatoryWatchEnabled &&
    !isMcpEnabled
  ) {
    return (
      <FlexCol className="h-screen bg-background items-center justify-center">
        <FlexCol className="items-center justify-center space-y-4">
          <h1 className="text-2xl font-semibold text-gray-800">
            No features enabled
          </h1>
          <p className="text-gray-600">
            Please contact your administrator to enable features for this
            workspace.
          </p>
        </FlexCol>
      </FlexCol>
    );
  }

  // Default landing page: regulatory watch if enabled, otherwise chat, otherwise literature reviews
  if (isRegulatoryWatchEnabled) {
    return (
      <Navigate
        to={`/workspace/${workspaceUname}/${paths.regulatoryWatch}/${regulatoryWatchPaths.allDocuments}`}
        replace
      />
    );
  }

  if (isChatEnabled) {
    return <AskPage />;
  }

  if (isLiteratureReviewEnabled) {
    return (
      <Navigate
        to={`/workspace/${workspaceUname}/${paths.literatureReviews}`}
        replace
      />
    );
  }

  if (isMcpEnabled) {
    return (
      <Navigate to={`/workspace/${workspaceUname}/${paths.mcp}`} replace />
    );
  }

  return null;
};
